import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import { GET_BUSINESS_BY_CATEGORYID } from "../../graphql/queries";
import CategoryBusinessCard from "./categoryBusinessCard"; 

const CategoryPage = () => {
  const { category } = useParams<{ category: string }>();

  const categoryId = Number(category?.split("_")[0]);

  const { city } = useParams<{ city: string }>();
  const cityId = Number(city?.split("_")[0]);

  const { loading, data } = useQuery(GET_BUSINESS_BY_CATEGORYID, {
    variables: {
      categoryId,
      cityId,
      countryId: Number(localStorage.getItem("currentCountryId")),
    },
  });

  return (
    <>
      {!loading && (
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="flex-start" // Align to the top of the window
          style={{ minHeight: "100vh" }} // Reduced padding to bring it closer to the top
        >
          <Grid
            item
            xs={12}
            md={9} // Medium size window (8 out of 12 columns)
            sx={{
               maxWidth: "600px", // Maximum width for content
              padding: "1rem", // Padding for better spacing
            }}
          >
            {data?.businessByCategory
              ?.filter((business: any) => {
                // Check if either the basic display flag is true or any booking type qualifies.
                return (
                  business.displayOnBookingPage === true ||
                  business.businessBookingTypes?.some(
                    (bookingType: { displayOnBookingPage: boolean }) =>
                      bookingType.displayOnBookingPage === true
                  )
                );
              })
              .map((business: any) => (
                <Box key={business.id} sx={{ marginBottom: 1 }}>
                  {/* Render the business card for each filtered business */}
                  <CategoryBusinessCard business={business} />
                </Box>
              ))}
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default CategoryPage;
